import { PolicyProductIdEnum } from 'outshared-lib';

export const productIconConfig = {
    [PolicyProductIdEnum.Liability]: 'liability',
    [PolicyProductIdEnum.Moped]: 'moped',
    [PolicyProductIdEnum.Caravan]: 'caravan',
    [PolicyProductIdEnum.Pet]: 'pet',
    [PolicyProductIdEnum.Bicycle]: 'bicycle',
    [PolicyProductIdEnum.Motorcycle]: 'motorcycle',
    [PolicyProductIdEnum.LegalAssistance]: 'legal',
    [PolicyProductIdEnum.Home]: 'house',
    [PolicyProductIdEnum.Car]: 'car',
    [PolicyProductIdEnum.Travel]: 'travel',
    [PolicyProductIdEnum.Accidents]: 'accident',
};
